import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useStore } from '@vromo/mobx-react';
import TrackingLinkStore from '../TrackingLinkStore';
import { withTheme } from '@emotion/react';
import { qaLabelTrackingLink } from '../../../common-qa-labels/tracking-link';

const Container = withTheme(styled.div`
    background: ${({ theme }) => theme.header || theme.background};
    max-height: 80px;
    flex-basis: 40px;
    text-align: center;
    padding: 10px 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`);

export default observer(function Header() {

    const { jobs: { items: [job] } } = useStore<TrackingLinkStore>('rootStore');

    if (!job || !job?.campaign?.logo?.url) {
        return null;
    }
    return (
        <Container>
            <img data-testid={qaLabelTrackingLink.headerLogo}
                src={job.campaign!.logo!.url!}
                style={{ height: '100%', width: '100%', objectFit: 'contain' }}
            />
        </Container>
    );
}
);
